import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=60c04cfc&scoped=true"
import script from "./SelectField.vue?vue&type=script&lang=ts"
export * from "./SelectField.vue?vue&type=script&lang=ts"
import style0 from "./SelectField.vue?vue&type=style&index=0&id=60c04cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c04cfc",
  null
  
)

export default component.exports